import React from 'react';

import _ from 'lodash';

import InputTextField from './InputTextField';
import InputSurveyQuestionPrompt from './InputSurveyQuestionPrompt';

import { SurveyQuestionStructure } from '../../Entities/SurveyQuestion';

import './InputSurveyQuestionResponse.scss';

class InputSurveyQuestionResponse extends React.Component {
  _onInputChange(inputId) {
    return value => {
      const response = _.cloneDeep(this.props.response);
      response.fields[inputId].value = value;

      this.props.onValueChange(response);
    };
  }


  onSurveyQuestionPromptChange = value => {
    this._onInputChange('next_question')(value);
  }


  handleRemoveResponseClick = () => {
    this.props.onValueChange(null);
  }


  handleAddFollowUpQuestionClick = () => {
    this._onInputChange('next_question')(new SurveyQuestionStructure());
  }


  handleRemoveFollowUpQuestionClick = () => {
    this._onInputChange('next_question')(null);
  }


  render() {
    const {
      response,
      ident,
      inputId,
      disableFollowUpQuestion = false,
      editMode
    } = this.props;

    const displayRemoveResponseButton = (
      editMode
    );
    const displayAddFollowUpQuestionButton = (
      !disableFollowUpQuestion &&
      editMode &&
      response.fields.next_question.value === null
    );
    const displayRemoveFollowUpQuestionButton = (
      !disableFollowUpQuestion &&
      editMode &&
      response.fields.next_question.value !== null
    );
    const renderActionContainer = (
      displayRemoveResponseButton ||
      displayAddFollowUpQuestionButton ||
      displayRemoveFollowUpQuestionButton
    );

    return (
      <div className="parkchirp--input-survey-question-response">
        <div className="parkchirp--input-survey-question-response--response-section">
          <InputTextField inputId={`${inputId}--${ident}--response`}
            value={response.fields.response.value}
            editMode={editMode}
            onChange={this._onInputChange('response')}
          />
          {(renderActionContainer) &&
            <div className="parkchirp--input-survey-question-response--action-container">
              {(displayRemoveResponseButton) &&
                <button type="button"
                  className="parkchirp--input-survey-question-response--action parkchirp--button-as-link"
                  onClick={this.handleRemoveResponseClick}>
                  Remove Response
                </button>
              }
              {(displayAddFollowUpQuestionButton) &&
                <button type="button"
                  className="parkchirp--input-survey-question-response--action parkchirp--button-as-link"
                  onClick={this.handleAddFollowUpQuestionClick}>
                  Add Follow Up Question
                </button>
              }
              {(displayRemoveFollowUpQuestionButton) &&
                <button type="button"
                  className="parkchirp--input-survey-question-response--action parkchirp--button-as-link"
                  onClick={this.handleRemoveFollowUpQuestionClick}>
                  Remove Follow Up Question
                </button>
              }
            </div>
          }
        </div>
        {(response.fields.next_question.value !== null) &&
          <InputSurveyQuestionPrompt inputId={`${inputId}--${ident}`}
            structure={response.fields.next_question.value}
            structureDepth={2}
            ident={0}
            editMode={editMode}
            onValueChange={this.onSurveyQuestionPromptChange}
          />
        }
      </div>
    );
  }
}
export default InputSurveyQuestionResponse;
